export var Modals;
(function (Modals) {
    Modals["AdminDailyReport"] = "admin-daily-report";
})(Modals || (Modals = {}));
